export default {
  data: () => ({
    pagination: {},
    defaultPerPage: 10,
  }),
  computed: {
    pages () {
      return Math.ceil(this.pagination.totalCount / this.defaultPerPage)
    },
  },
  created () {
    this.$set(this.pagination, 'page', 1)
    this.$set(this.pagination, 'perPage', this.defaultPerPage)
    this.$set(this.pagination, 'totalCount', 1)
  },
  methods: {
    pageChange () {
      throw new Error("You must implement pageChange")
    },
    pageParams (params = {}) {
      return {
        page: this.pagination.page,
        per: this.pagination.perPage,
      }.deepMerge(params)
    },
  }
}
